module.exports = __webpack_public_path__ + "static/media/signage-industrial-img3.98bf3890.jpg";